import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const Compare = () => {
  const features = [
    {
      category: "Core Scheduling",
      items: [
        { feature: "Showing Scheduling", showingbooker: true, showingtime: true, showdigs: true, tenantturner: true },
        { feature: "Calendar Integration", showingbooker: true, showingtime: true, showdigs: true, tenantturner: true },
        { feature: "Automated Confirmations", showingbooker: true, showingtime: true, showdigs: true, tenantturner: true },
      ]
    },
    {
      category: "Tenant Compliance (Occupied Properties)",
      items: [
        { feature: "24/48-Hour Tenant Notice Automation", showingbooker: true, showingtime: false, showdigs: false, tenantturner: false },
        { feature: "Legal Compliance Audit Trail", showingbooker: true, showingtime: false, showdigs: false, tenantturner: false },
        { feature: "LA Housing Dept Compliance", showingbooker: true, showingtime: false, showdigs: false, tenantturner: false },
        { feature: "Multi-Channel Notices (SMS/Email/Mail)", showingbooker: true, showingtime: false, showdigs: false, tenantturner: false },
        { feature: "PDF Compliance Reports", showingbooker: true, showingtime: false, showdigs: false, tenantturner: false },
        { feature: "Certified Mail Integration", showingbooker: true, showingtime: false, showdigs: false, tenantturner: false },
      ]
    },
    {
      category: "Agent Protection",
      items: [
        { feature: "Liability Documentation", showingbooker: true, showingtime: false, showdigs: false, tenantturner: false },
        { feature: "Tenant Rights Compliance", showingbooker: true, showingtime: false, showdigs: false, tenantturner: false },
        { feature: "Digital Signature Capture", showingbooker: true, showingtime: false, showdigs: false, tenantturner: false },
      ]
    },
    {
      category: "Pricing",
      items: [
        { feature: "100% Free for Property Owners", showingbooker: true, showingtime: false, showdigs: false, tenantturner: false },
        { feature: "No MLS Requirement", showingbooker: true, showingtime: false, showdigs: true, tenantturner: true },
        { feature: "Unlimited Properties", showingbooker: true, showingtime: false, showdigs: false, tenantturner: false },
      ]
    }
  ];

  const competitors = [
    {
      name: "ShowingTime",
      logo: "🏠",
      description: "Owned by Zillow. Industry standard for vacant property showings. Requires MLS membership.",
      focus: "Vacant Properties",
      pricing: "$$$$ (MLS Required)"
    },
    {
      name: "Showdigs",
      logo: "🤖",
      description: "AI-powered showing automation for property managers. Good for vacant rentals.",
      focus: "Vacant Rentals",
      pricing: "$$"
    },
    {
      name: "Tenant Turner",
      logo: "🔑",
      description: "Tenant screening and showing management. Focused on vacant property leasing.",
      focus: "Tenant Screening",
      pricing: "$$"
    }
  ];

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, padding: '32px 16px', maxWidth: '1000px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ fontSize: '1.5rem', marginBottom: '12px', color: '#1a1a2e', fontWeight: '700' }}>
            Why ShowingBooker?
          </h1>
          <p style={{ fontSize: '0.9rem', color: '#666', maxWidth: '600px', margin: '0 auto', lineHeight: '1.5' }}>
            The only showing management platform built specifically for <strong>tenant-occupied properties</strong> in regulated markets like Los Angeles.
          </p>
        </div>

        {/* Key Differentiator */}
        <div style={{
          background: 'linear-gradient(135deg, #2d5a27 0%, #1a3518 100%)',
          borderRadius: '8px',
          padding: '28px 24px',
          color: 'white',
          textAlign: 'center',
          marginBottom: '40px'
        }}>
          <h2 style={{ fontSize: '1rem', marginBottom: '8px', fontWeight: '600' }}>
            Our Competitors Focus on Vacant Properties.
          </h2>
          <h2 style={{ fontSize: '1.25rem', marginBottom: '12px', fontWeight: '700' }}>
            We Protect You on <span style={{ textDecoration: 'underline' }}>Occupied</span> Ones.
          </h2>
          <p style={{ fontSize: '0.85rem', opacity: 0.9, maxWidth: '550px', margin: '0 auto', lineHeight: '1.5' }}>
            When tenants are involved, you need legal compliance documentation, proper notice delivery, and an audit trail.
            ShowingTime, Showdigs, and Tenant Turner don't offer this. We do.
          </p>
        </div>

        {/* Competitor Cards */}
        <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#1a1a2e', fontSize: '1.1rem', fontWeight: '600' }}>
          The Competition
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '16px',
          marginBottom: '40px'
        }}>
          {competitors.map((comp, index) => (
            <div key={index} style={{
              background: '#f8f9fa',
              borderRadius: '8px',
              padding: '20px',
              border: '1px solid #e0e0e0'
            }}>
              <div style={{ fontSize: '1.5rem', marginBottom: '8px' }}>{comp.logo}</div>
              <h3 style={{ marginBottom: '6px', color: '#1a1a2e', fontSize: '0.95rem', fontWeight: '600' }}>{comp.name}</h3>
              <p style={{ color: '#666', fontSize: '0.8rem', marginBottom: '12px', lineHeight: '1.5' }}>{comp.description}</p>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem' }}>
                <span style={{ color: '#888' }}>Focus: {comp.focus}</span>
                <span style={{ color: '#888' }}>{comp.pricing}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Feature Comparison Table */}
        <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#1a1a2e', fontSize: '1.1rem', fontWeight: '600' }}>
          Feature Comparison
        </h2>
        <div style={{ overflowX: 'auto', marginBottom: '40px' }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            background: 'white',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            fontSize: '0.8rem'
          }}>
            <thead>
              <tr style={{ background: '#1a1a2e', color: 'white' }}>
                <th style={{ padding: '12px', textAlign: 'left', minWidth: '200px' }}>Feature</th>
                <th style={{ padding: '12px', textAlign: 'center', background: '#2d5a27' }}>ShowingBooker</th>
                <th style={{ padding: '12px', textAlign: 'center' }}>ShowingTime</th>
                <th style={{ padding: '12px', textAlign: 'center' }}>Showdigs</th>
                <th style={{ padding: '12px', textAlign: 'center' }}>Tenant Turner</th>
              </tr>
            </thead>
            <tbody>
              {features.map((category, catIndex) => (
                <React.Fragment key={catIndex}>
                  <tr style={{ background: '#f0f0f0' }}>
                    <td colSpan={5} style={{ padding: '10px 12px', fontWeight: '600', color: '#1a1a2e', fontSize: '0.8rem' }}>
                      {category.category}
                    </td>
                  </tr>
                  {category.items.map((item, itemIndex) => (
                    <tr key={itemIndex} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '10px 12px', color: '#333' }}>{item.feature}</td>
                      <td style={{ padding: '10px 12px', textAlign: 'center', background: '#f8fff8' }}>
                        {item.showingbooker ? (
                          <span style={{ color: '#2d5a27', fontSize: '1rem' }}>✓</span>
                        ) : (
                          <span style={{ color: '#ccc', fontSize: '1rem' }}>✗</span>
                        )}
                      </td>
                      <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                        {item.showingtime ? (
                          <span style={{ color: '#2d5a27', fontSize: '1rem' }}>✓</span>
                        ) : (
                          <span style={{ color: '#dc3545', fontSize: '1rem' }}>✗</span>
                        )}
                      </td>
                      <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                        {item.showdigs ? (
                          <span style={{ color: '#2d5a27', fontSize: '1rem' }}>✓</span>
                        ) : (
                          <span style={{ color: '#dc3545', fontSize: '1rem' }}>✗</span>
                        )}
                      </td>
                      <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                        {item.tenantturner ? (
                          <span style={{ color: '#2d5a27', fontSize: '1rem' }}>✓</span>
                        ) : (
                          <span style={{ color: '#dc3545', fontSize: '1rem' }}>✗</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>

        {/* Bottom CTA */}
        <div style={{
          textAlign: 'center',
          background: '#f8f9fa',
          borderRadius: '8px',
          padding: '32px 24px',
          marginBottom: '32px'
        }}>
          <h2 style={{ marginBottom: '12px', color: '#1a1a2e', fontSize: '1.1rem', fontWeight: '600' }}>
            Ready to Protect Yourself on Occupied Properties?
          </h2>
          <p style={{ color: '#666', marginBottom: '20px', maxWidth: '500px', margin: '0 auto 20px', fontSize: '0.85rem', lineHeight: '1.5' }}>
            Join agents and property managers who trust ShowingBooker for legal compliance on tenant-occupied showings.
          </p>
          <Link to="/register" style={{
            display: 'inline-block',
            background: '#2d5a27',
            color: 'white',
            padding: '12px 28px',
            borderRadius: '6px',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '0.9rem'
          }}>
            Get Started Free
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Compare;
